import $ from "jquery";
import local_en from "./en";
import local_hu from "./hu";
import local_it from "./it";
import local_cn from "./cn";
import local_de from "./de";

import admin_local_en from "./admin_en";
import admin_local_hu from "./admin_hu";
import admin_local_it from "./admin_it";
import admin_local_cn from "./admin_cn";
import admin_local_de from "./admin_de";
import admin_menuitem_help_en from "./admin_menuitem_help_en";
import admin_menuitem_help_hu from "./admin_menuitem_help_hu";
import admin_menuitem_help_it from "./admin_menuitem_help_it";
import admin_menuitem_help_cn from "./admin_menuitem_help_cn";
import admin_menuitem_help_de from "./admin_menuitem_help_de";
import { _log } from "../js/auth";

function changeLanguage() {
  console.log("changeLanguage");
  $("#changeLanguage.modal").modal("show");
}

export const locals = {
  hu: local_hu,
  en: local_en,
  it: local_it,
  cn: local_cn,
  de: local_de
};

export const admin_locals = {
  hu: { ...admin_local_hu, ...admin_menuitem_help_hu },
  en: { ...admin_local_en, ...admin_menuitem_help_en },
  it: { ...admin_local_it, ...admin_menuitem_help_it },
  cn: { ...admin_local_cn, ...admin_menuitem_help_cn },
  de: { ...admin_local_de, ...admin_menuitem_help_de }
};

let local;
let admin_local;
let languages = ["en", "hu", "it", "de", "cn"];
export const languages_and_countries = {
  en: ["gb", "us"],
  hu: ["hu"],
  it: ["it"],
  de: ["de"],
  cn: ["cn"]
};

export const initLanguage = () => {
  try {
    if (typeof localStorage.language == "undefined" || localStorage.language === "undefined") {
      if (typeof localStorage.language != "undefined" && localStorage.language !== "" && localStorage.language !== "undefined") {
        if (languages_and_countries[localStorage.language]) localStorage.country = languages_and_countries[localStorage.language][0];
      } else {
        var userLang = navigator.language || navigator.userLanguage;
        localStorage.language = userLang.split("-")[0];
        if (languages_and_countries[localStorage.language]) localStorage.country = languages_and_countries[localStorage.language][0];
      }
    }
    if (!languages_and_countries[localStorage.language]) {
      localStorage.language = "hu";
    }
    local = locals[localStorage.language];
    admin_local = admin_locals[localStorage.language];
    console.log("Language is", localStorage.language);
    if (typeof localStorage.country == "undefined" || localStorage.country !== "undefined") {
      if (languages_and_countries[localStorage.language]) {
        localStorage.country = languages_and_countries[localStorage.language][0];
      }
    }
    $("html").attr("lang", localStorage.language);
  } catch (ex) {
    console.log(ex.stack);
    if (typeof localStorage.language != "undefined") alert("Language '" + localStorage.language + "' not found! Switching to 'en'!");
    localStorage.language = "en";
    if (languages_and_countries[localStorage.language]) localStorage.country = languages_and_countries[localStorage.language][0];
    window.get("login/setLanguage/" + localStorage.language).done(() => {
      _log("LOGIN: Language set to 'en' due to error");
      setTimeout(() => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }, 1000);
    });
  }
}

initLanguage();

export default { local, admin_local, changeLanguage, languages, languages_and_countries };
